<h1>Groupes participants</h1>
<a [routerLink]="['iackathon-deliverables']">Bibliothèque des livrables</a>

@if (isLoading()) {
    <mat-spinner></mat-spinner>
} @else {
    @for (groupSave of groupSaves(); track $index) {
        <app-iackathon-group [save]="groupSave"></app-iackathon-group>
    }
}
